import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-496d2b4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tag-indicator" }
const _hoisted_2 = { class: "tag-indicator__title" }
const _hoisted_3 = {
  class: "progress-ring",
  width: "30",
  height: "30"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "progress-ring__circle-full",
  stroke: "grey",
  "stroke-width": "4",
  fill: "transparent",
  r: "10",
  cx: "15",
  cy: "15"
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "tag-indicator__description"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.skills.title')), 1),
    (_openBlock(), _createElementBlock("svg", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("circle", {
        ref: "progressCircleCreation",
        class: "progress-ring__circle",
        stroke: "grey",
        "stroke-width": "4",
        fill: "transparent",
        r: "10",
        cx: "15",
        cy: "15",
        style: _normalizeStyle(_ctx.strokePropsCreation)
      }, null, 4),
      _withDirectives(_createElementVNode("circle", {
        ref: "progressCircleCompletion",
        class: "progress-ring__circle-completion",
        stroke: "grey",
        "stroke-width": "4",
        fill: "transparent",
        r: "10",
        cx: "15",
        cy: "15",
        style: _normalizeStyle(_ctx.strokePropsCompletion)
      }, null, 4), [
        [_vShow, _ctx.reachedLimitForCreation]
      ])
    ])),
    (_ctx.hasTag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!_ctx.reachedLimitForCreation)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.skills.indicator.creation', _ctx.leftTagsCountForCreation)), 1))
            : _createCommentVNode("", true),
          (_ctx.reachedLimitForCreation && !_ctx.reachedLimitForCompletion)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.skills.indicator.completion', _ctx.leftTagsCountForCompletion)), 1))
            : _createCommentVNode("", true),
          (_ctx.reachedLimitForCreation && _ctx.reachedLimitForCompletion)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.skills.indicator.more', _ctx.maxTagCount)), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, _ctx.hasTag]
  ])
}